import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Zap } from 'lucide-react';
export function MechanismDiagram() {
  return <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100" data-id="element-41">
      <div className="bg-slate-900 text-white text-center py-4 px-6" data-id="element-42">
        <h3 className="font-serif text-xl font-bold" data-id="element-43">
          WIE RYLTE IN DER TIEFE WIRKT
        </h3>
      </div>

      <div className="p-6 space-y-8" data-id="element-44">
        {/* Red Light Panel */}
        <div className="relative bg-rose-50 rounded-xl p-6 border border-rose-100 overflow-hidden" data-id="element-45">
          <div className="absolute right-0 top-0 w-32 h-32 bg-rose-200/50 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-46"></div>
          <div className="flex items-start gap-4 relative z-10" data-id="element-47">
            <div className="bg-rose-500 text-white p-3 rounded-lg shadow-md" data-id="element-48">
              <Zap className="w-6 h-6" data-id="element-49" />
            </div>
            <div data-id="element-50">
              <h4 className="font-bold text-slate-900 mb-2" data-id="element-51">
                660-850nm Rotes & Nahinfrarotes Licht
              </h4>
              <p className="text-sm text-slate-700 leading-relaxed" data-id="element-52">
                Dringt{' '}
                <span className="font-semibold text-rose-700" data-id="element-53">
                  3 bis 5 Millimeter
                </span>{' '}
                in die Dermis ein. Aktiviert Mitochondrien, unterstützt die
                Kollagensynthese und reduziert unterschwellige Entzündungen.
              </p>
            </div>
          </div>

          {/* Visual representation of skin layers */}
          <div className="mt-6 flex flex-col gap-1" data-id="element-54">
            <div className="h-2 bg-rose-200 rounded-t-sm w-full relative" data-id="element-55">
              <span className="absolute -top-5 text-[10px] font-bold text-rose-800 uppercase tracking-wider" data-id="element-56">
                Epidermis (0.5mm)
              </span>
            </div>
            <div className="h-6 bg-rose-300 w-full relative flex items-center justify-center overflow-hidden" data-id="element-57">
              <div className="absolute inset-0 opacity-30" style={{
              backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
              backgroundSize: '10px 10px'
            }} data-id="element-58"></div>
            </div>
            <div className="h-12 bg-rose-400 rounded-b-sm w-full relative flex items-center justify-center overflow-hidden" data-id="element-59">
              <span className="absolute left-2 text-[10px] font-bold text-white uppercase tracking-wider z-10" data-id="element-60">
                Dermis (3-5mm)
              </span>
              <div className="absolute inset-0 opacity-50" style={{
              backgroundImage: 'linear-gradient(45deg, rgba(255,255,255,0.2) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.2) 75%, transparent 75%, transparent)',
              backgroundSize: '20px 20px'
            }} data-id="element-61"></div>
              <div className="w-full flex justify-around px-4 z-10" data-id="element-62">
                {[...Array(5)].map((_, i) => <motion.div key={i} animate={{
                y: [0, 5, 0],
                opacity: [0.5, 1, 0.5]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                delay: i * 0.2
              }} className="w-1 h-8 bg-white/80 rounded-full" data-id="element-63" />)}
              </div>
            </div>
          </div>
        </div>

        {/* Microcurrent Panel */}
        <div className="relative bg-blue-50 rounded-xl p-6 border border-blue-100 overflow-hidden" data-id="element-64">
          <div className="absolute right-0 top-0 w-32 h-32 bg-blue-200/50 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-65"></div>
          <div className="flex items-start gap-4 relative z-10" data-id="element-66">
            <div className="bg-blue-500 text-white p-3 rounded-lg shadow-md" data-id="element-67">
              <Activity className="w-6 h-6" data-id="element-68" />
            </div>
            <div data-id="element-69">
              <h4 className="font-bold text-slate-900 mb-2" data-id="element-70">
                Galvanischer Mikrostrom (EMS)
              </h4>
              <p className="text-sm text-slate-700 leading-relaxed" data-id="element-71">
                Aktiviert sanft den{' '}
                <span className="font-semibold text-blue-700" data-id="element-72">
                  Musculus orbicularis oculi
                </span>{' '}
                und unterstützt die Lymphdrainage. Der Muskel beginnt wieder,
                das Gewebe zu halten.
              </p>
            </div>
          </div>

          {/* Visual representation of muscle/lymph */}
          <div className="mt-6 h-16 bg-blue-100 rounded-lg relative overflow-hidden flex items-center px-4" data-id="element-73">
            <div className="absolute inset-0 opacity-20" style={{
            backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 10px, #3b82f6 10px, #3b82f6 20px)'
          }} data-id="element-74"></div>
            <motion.div animate={{
            x: [-100, 300]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} className="h-full w-32 bg-gradient-to-r from-transparent via-blue-400/40 to-transparent absolute top-0 left-0 skew-x-12" data-id="element-75" />
            <span className="relative z-10 text-[10px] font-bold text-blue-900 uppercase tracking-wider" data-id="element-76">
              Muskelstimulation & Lymphfluss
            </span>
          </div>
        </div>
      </div>
    </div>;
}